import { z } from "zod";

// A client's cumulative team roster — every team ever seen in an uploaded
// usage CSV, kept even in months it's absent from the export. `excluded`
// lets staff prune entries that were never real teams (spare-device rows,
// trial teams) without needing to scrub historical CSVs. See
// packages/backend/src/features/teams/team-roster.repository.ts.
export const TeamRosterEntrySchema = z.object({
  id: z.string().uuid(),
  clientId: z.string().uuid(),
  teamName: z.string(),
  firstSeenYear: z.number().int(),
  firstSeenMonth: z.number().int().min(1).max(12),
  excluded: z.boolean(),
  excludedAt: z.string().datetime({ offset: true }).nullable(),
  excludedByUserId: z.string().nullable(),
});

export type TeamRosterEntry = z.infer<typeof TeamRosterEntrySchema>;

export const TeamRosterListResponseSchema = z.object({
  items: z.array(TeamRosterEntrySchema),
});

export type TeamRosterListResponse = z.infer<typeof TeamRosterListResponseSchema>;

export const UpdateTeamRosterEntryRequestSchema = z.object({
  excluded: z.boolean(),
});

export type UpdateTeamRosterEntryRequest = z.infer<typeof UpdateTeamRosterEntryRequestSchema>;
